import { UserProfileInfoContainer } from "pages/Users/UserProfileInfo/styled";
import styled from "styled-components";

export const CreatorUserProfileInfoContainer = styled(UserProfileInfoContainer)`
  .edit-info-container {
    grid-template-columns: repeat(1, 1fr);
    gap: 8px;

    .note-info-section {
      width: fit-content;
      margin-top: 8px;
    }
  }

  .user-role-badge {
    background:
      linear-gradient(
        0deg,
        rgba(140, 99, 204, 0.2) 0%,
        rgba(140, 99, 204, 0.2) 100%
      ),
      #fff !important;

    span {
      color: #8c63cc !important;
    }
  }
`;
